import moment from 'moment'
import 'moment/locale/vi'

// Set Vietnamese locale globally
moment.locale('vi')

export default moment
